export default {
  nav: {
    home: 'Home',
    categories: 'Categories',
    cart: 'Cart',
    orders: 'Orders',
    wishlist: 'Wishlist',
    vendor: 'Vendor',
    notifications: 'Notifications',
    profile: 'Profile',
    addresses: 'Addresses',
    paymentMethods: 'Payment Methods',
    security: 'Security',
    settings: 'Settings',
    storyEditor: 'Story Editor',
    more: 'More',
    closeMenu: 'Close Menu',
    language: 'Language',
    help: 'Help & Support',
  },
  header: {
    welcome: 'Welcome',
    searchPlaceholder: 'Search products, brands and categories...',
    searchMobile: 'Search...',
    search: 'Search',
    delivery: 'Delivery',
    pickup: 'Pickup',
    schedule: 'Schedule',
    setAddress: 'Set Address',
    inStorePickup: 'In-store Pickup',
    notifications: 'Notifications',
    customer: 'Customer',
    guest: 'Guest',
    selectLocation: 'Select Location',
    address: 'Address',
    scheduledSelected: 'Scheduled delivery selected',
    courierSelected: 'Courier delivery selected',
    pickupSelected: 'In-store pickup selected',
    searchingFor: 'Looking for',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    confirm: 'Confirm',
    back: 'Back',
    backToProfile: 'Back to Profile',
    next: 'Next',
    close: 'Close',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    empty: 'Empty',
    seeAll: 'See All',
    appName: 'Bazaarak',
    appNameEn: 'Bazaarak',
    currency: 'USD',
    viewAll: 'View All',
    items: 'items',
    store: 'Store',
    clear: 'Clear',
    actions: 'Actions',
    email: 'Email',
    phone: 'Phone',
    enabled: 'Enabled',
    disabled: 'Disabled',
    enable: 'Enable',
  },
  auth: {
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    phone: 'Phone',
    forgotPassword: 'Forgot Password',
    signInRequired: 'Sign In Required',
    addressSignInPrompt: 'Please sign in to manage your delivery addresses',
    unauthorized: 'Session expired. Please sign in again.',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    createAccount: 'Create Account',
    welcomeBack: 'Welcome back!',
    createYourAccount: 'Create your account',
    customer: 'Customer',
    vendor: 'Vendor',
    name: 'Name',
    fullName: 'Full Name',
    storeName: 'Store Name',
    confirmPassword: 'Confirm Password',
    enterYourName: 'Enter your name',
    emailOrUsername: 'Email / Username',
    enterEmailOrUsername: 'Enter your email or username',
    enterYourPassword: 'Enter your password',
    confirmYourPassword: 'Confirm your password',
    enterStoreName: 'Enter your store name',
    enterPhoneNumber: '+1 234 567 8900',
    rememberMe: 'Remember me',
    orContinueWith: 'Or continue with',
    continueWithGoogle: 'Continue with Google',
    continueWithApple: 'Continue with Apple',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    backToHome: 'Back to Home',
    signingIn: 'Signing in...',
    creatingAccount: 'Creating account...',
    verifiedVendor: 'Verified Vendor',
  },
  product: {
    addToCart: 'Add to Cart',
    addToWishlist: 'Add to Wishlist',
    buyNow: 'Buy Now',
    outOfStock: 'Out of Stock',
    discount: 'Discount',
    price: 'Price',
    originalPrice: 'Original Price',
    reviews: 'reviews',
    description: 'Description',
    related: 'Related Products',
    inStock: 'in stock',
    quantity: 'Quantity',
    availability: 'Availability',
    selectVariant: 'Select Variant',
    save: 'Save',
    notFound: 'Product Not Found',
    notFoundDesc: 'This product does not exist or has been removed.',
    browseProducts: 'Browse Products',
    home: 'Home',
    addingToCart: 'Adding...',
    addingToWishlist: 'Adding...',
    addedToCart: 'added to cart!',
    addedToWishlist: 'Added to wishlist!',
    failedToLoad: 'Failed to load product',
    failedToAddCart: 'Failed to add to cart',
    failedToAddWishlist: 'Failed to add to wishlist',
    viewCart: 'View Cart',
    products: 'products',
    nSellers: '{{count}} sellers',
    fromPrice: 'from',
    priceRange: 'from €{{from}} to €{{to}}',
    chooseStore: 'Choose a store',
    soldBySelected: 'Sold by selected store',
    availableAtStores: 'Available at {{count}} stores',
    store: 'Store',
    multipleVariants: '{{count}} options',
  },
  cart: {
    title: 'Shopping Cart',
    empty: 'Your cart is empty',
    emptyDesc: 'Start shopping to add items to your cart',
    total: 'Total',
    checkout: 'Proceed to Checkout',
    continueShopping: 'Continue Shopping',
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    tax: 'Tax (19%)',
    discount: 'Discount',
    couponCode: 'Coupon Code',
    enterCode: 'Enter code',
    apply: 'Apply',
    couponApplied: 'Coupon applied (10% off)',
    free: 'FREE',
    processing: 'Processing...',
    secureCheckout: 'Secure checkout powered by Stripe',
    signIn: 'Please Sign In',
    signInDesc: 'Sign in to view your shopping cart',
    itemsInCart: 'items in your cart',
    each: 'each',
    impulseTitle: 'Before you checkout…',
    impulseSubtitle: 'Last-minute finds',
    impulseHot: 'Hot',
    impulseDeal: 'Deal',
    impulseCampaignDesc: 'Limited-time deals — grab before checkout!',
    impulseShopDeals: 'See deals',
    impulseProductDesc: '{{percent}}% off — add before you pay',
    impulseProductStoreDesc: '{{percent}}% off · {{store}}',
    impulseViewProduct: 'View product',
    impulseAddNow: 'Grab it',
    impulseStoreDesc: 'Store picks & extras while you checkout',
    impulseVisitStore: 'Visit store',
    impulseStoreBadge: 'Store',
  },
  categories: {
    browse: 'Browse Categories',
    explore: 'Explore our extensive collection across all categories',
    all: 'All Categories',
    electronics: 'Electronics',
    fashion: 'Fashion & Clothing',
    home: 'Home & Garden',
    sports: 'Sports & Outdoors',
    books: 'Books & Media',
    beauty: 'Beauty & Health',
    toys: 'Toys & Games',
    automotive: 'Automotive',
    jewelry: 'Jewelry & Watches',
    pet: 'Pet Supplies',
    office: 'Office Supplies',
    productsAvailable: 'products available',
    subcategories: 'Subcategories',
    noProductsFound: 'No products found for',
    products: 'Products',
  },
  home: {
    browseByCategory: 'Shop by Category',
    browseCategoryDesc: 'Explore our wide range of premium categories',
    featuredProducts: 'Featured Products',
    featuredDesc: 'Handpicked items just for you',
    nearYouProducts: 'Near you right now',
    nearYouDesc: 'Picked for your area and local time',
    topProducts: 'Top Products',
    topProductsDesc: 'Best-selling items this week',
    sold: 'sold',
    youMightLike: 'You might like',
    youMightLikeDesc: 'Handpicked products from your favorite stores',
    trendingNow: 'Trending Now',
    trendingDesc: 'Stay ahead with the latest trends',
    premiumMarketplace: 'Premium Marketplace',
    heroTitle1: 'Discover',
    heroTitle2: 'Premium Products',
    heroDesc: 'Experience luxury shopping with our curated collection of premium brands and exclusive products. Your journey to excellence starts here.',
    exploreNow: 'Explore Now',
    becomeVendor: 'Become a Vendor',
    products: 'Products',
    vendors: 'Vendors',
    happyCustomers: 'Happy Customers',
    deliverTo: 'Deliver to',
    selectAddress: 'Select Address',
    schedule: 'Schedule',
    selectDateTime: 'Select Date & Time',
    popularSearches: 'POPULAR SEARCHES',
    shopNow: 'Shop Now',
    explore: 'Explore',
    summerCollection: 'Summer Collection 2024',
    summerDesc: 'Discover the hottest trends this season',
    smartHome: 'Smart Home Essentials',
    smartHomeDesc: 'Transform your living space',
    wellness: 'Wellness & Self-Care',
    wellnessDesc: 'Premium products for your wellbeing',
    fashion: 'Fashion',
    tech: 'Tech',
    beauty: 'Beauty',
    selectDeliveryAddress: 'Select Delivery Address',
    scheduleDelivery: 'Schedule Delivery',
    addNewAddress: 'Add New Address',
    selectDate: 'Select Date',
    selectTimeSlot: 'Select Time Slot',
    confirmSchedule: 'Confirm Schedule',
    topVendors: 'Top Shops',
    topVendorsDesc: 'Trusted stores near you',
    topRatedNearYou: 'Top rated near you',
    discoverWhatYouLike: 'Discover what you like',
    sponsored: 'Sponsored',
    filter: {
      'all': 'All',
      'wishlist': 'Wishlist',
      'on-sale': 'On Sale',
      'free-shipping': 'Free Shipping',
      'new-arrivals': 'New Arrivals',
      'best-seller': 'Best Seller',
      'top-rated': 'Top Rated',
      'price-drop': 'Price Drop',
      'express': 'Express',
      'premium': 'Premium',
    },
    topStores: 'Top Stores',
    nearBadge: 'Near',
    since: 'Since',
    delivery: 'Delivery',
    noDelivery: 'No delivery',
    freeShipping: 'Free shipping',
    specialBadge: 'Special',
    storePromoFallback: 'Special discount up to 30%',
    flashSale: 'Orange discount',
    flashSaleDesc: 'Limited-time campaign prices',
    flashSaleBadge: 'Deal',
    campaignStockLeft: '{{count}} left!',
    campaignPack: 'Pack of {{count}}',
    seasonalCampaign: 'Seasonal campaign',
  },
  supermarket: {
    searchPlaceholder: 'Search in Bazaarak supermarket',
    promoTitle: 'Win big cash prizes!',
    promoCta: 'Enter draw',
    modeSuper: 'Supermarket',
    modeSuperHint: 'Instant delivery',
    modeHyper: 'Hypermarket',
    modeHyperHint: 'Scheduled delivery',
    previousPurchases: 'Previous purchases',
    suggestedForYou: 'Suggested for you',
    nearbyStores: '{{count}} stores around you',
    eta: 'Up to 30 min',
    viewAllStores: 'View all stores',
    shopCategories: 'Shop by category',
    railOffers: 'Special offers for you',
    railTrending: 'Popular right now',
    railFresh: 'Fresh picks',
    homeEntryTitle: 'Bazaarak supermarket',
    homeEntryHint: 'Instant delivery & daily deals',
    turbo: 'Turbo delivery',
    bannerFallbackTitle: 'Special offers',
    bannerFallbackSub: 'Up to 30% off',
    productCountBadge: '{{count}} products',
  },
  campaign: {
    notFound: 'Campaign not found',
    loadFailed: 'Failed to load campaign',
    ended: 'This campaign has ended.',
    notStarted: 'This campaign has not started yet.',
    paused: 'This campaign is paused.',
    unavailable: 'This campaign is not available right now.',
    noProducts: 'No products in this campaign yet.',
    noProductsInactive: 'Products are only shown while the campaign is active.',
    productCount: '{{count}} products',
    visitStore: 'Visit {{name}}',
    viewAll: 'View all ({{count}})',
    itemNotFound: 'Campaign item not found',
    flashOffer: 'Flash offer',
    packOffer: 'Pack offer',
    campaignPrice: 'Campaign price',
    pricePerUnit: '{{price}} per item',
    aboutOffer: 'About this offer',
    backToCampaign: 'Back to all campaign items',
    addOfferToCart: 'Add offer to cart',
    addPackToCart: 'Add pack to cart',
    notAvailableNow: 'Not available now',
  },
  orders: {
    title: 'My Orders',
    totalOrders: 'total orders',
    noOrders: 'No orders found',
    noOrdersDesc: "Start shopping to see your orders here!",
    signIn: 'Please Sign In',
    signInDesc: 'Sign in to view your orders',
    all: 'All',
    pending: 'Pending payment',
    paid: 'Paid',
    processing: 'Processing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    orderedOn: 'Ordered on',
    estDelivery: 'Est. delivery:',
    viewDetails: 'View Details',
    hideDetails: 'Hide Details',
    track: 'Track',
    orderItems: 'Order Items',
    priceDetails: 'Price Details',
    shippingAddress: 'Shipping Address',
    tracking: 'Tracking:',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    tax: 'Tax (19%)',
    total: 'Total',
    item: 'item',
    items: 'items',
    qty: 'Qty:',
    payNow: 'Pay Now',
    unknownStatus: 'Unknown Status',
    stageProgress: 'Order progress',
    stagePayment: 'Payment',
    stagePaymentHint: 'Awaiting payment',
    stagePaid: 'Paid',
    stagePaidHint: 'Payment confirmed',
    stagePreparing: 'Preparing',
    stagePreparingHint: 'Store is packing',
    stageShipped: 'On the way',
    stageShippedHint: 'Out for delivery',
    stageDelivered: 'Delivered',
    stageDeliveredHint: 'Order completed',
    stageCurrent: 'Current',
    stageDone: 'Done',
    refunded: 'Refunded',
  },
  profile: {
    title: 'Profile',
    backToHome: 'Back to Home',
    editProfile: 'Edit Profile',
    saveChanges: 'Save Changes',
    memberSince: 'Member since',
    welcomeBack: 'Welcome back, {{name}}',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    birthDate: 'Date of birth',
    birthDateHint: 'Scroll to pick your birthday',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    myOrders: 'My Orders',
    viewAllPurchases: 'View all purchases',
    savedItems: 'saved items',
    manageLocations: 'Manage locations',
    savedCards: 'Saved cards',
    preferences: 'Preferences',
    passwordAnd2FA: 'Password & 2FA',
    language: 'Language',
    helpSupport: '24/7 assistance',
    logout: 'Logout',
    confirmLogout: 'Confirm Logout',
    confirmLogoutDesc: 'Are you sure you want to logout from your account?',
    uploadProfilePicture: 'Upload Profile Picture',
    clickToUpload: 'Click to upload or drag and drop',
    chooseFile: 'Choose File',
    version: 'BAZARAK v1.0.0',
    terms: 'Terms',
    privacy: 'Privacy',
    backToProfile: 'Back to Profile',
    imageTooLarge: 'Image must be under 5MB',
    yourPoints: 'Your points',
    yourLevel: 'Your level',
    levelBronze: 'Bronze',
    levelSilver: 'Silver',
    levelGold: 'Gold',
    levelDiamond: 'Diamond',
    levelLegend: 'Legend',
    pointsToNext: 'You need {{count}} more points for the next level',
    maxLevel: 'You reached the highest level',
    memberOfSince: 'Bazaarak member since {{date}}',
    proTitle: 'Bazaarak Pro',
    proDesc: 'A more luxurious experience with special benefits',
    proUpgrade: 'Upgrade to Pro',
    proExtend: 'Extend Pro',
    proActive: 'Active',
    proActivated: 'Pro membership activated',
    proActiveUntil: 'Active until {{date}}',
    proBenefitShipping: 'Free shipping',
    proBenefitDiscounts: 'Exclusive discounts',
    proBenefitSupport: 'Priority support',
    proBenefitReturns: 'Free returns',
    proComingSoon: 'Pro membership is coming soon',
    inviteTitle: 'Invite friends',
    inviteDesc: 'Invite your friends and earn points and rewards',
    inviteCode: 'Your invite code',
    inviteCta: 'Invite and earn points',
    inviteCopied: 'Invite code copied',
    enterInviteCode: 'Enter invite code',
    applyInvite: 'Apply code',
    referralApplied: 'Referral bonus applied',
    referralBonusHint: 'You and your friend each earn {{count}} points',
    shareInviteText: 'Join me on Bazaarak! Use my invite code: {{code}}',
    orderAll: 'All orders',
    orderProcessing: 'Processing',
    orderShipped: 'Shipped',
    orderDelivered: 'Delivered',
    orderReturns: 'Returns',
    accountInfo: 'Account info',
    giftCards: 'Gift cards',
    giftCardsSoon: 'Gift cards are coming soon',
    supportHelp: 'Support & help',
    settings: 'Settings',
    levelPlatinum: 'Platinum',
    pullForMemberPass: 'Pull down — member festival pass',
    pullToHidePass: 'Pull up to hide pass',
    memberPassEyebrow: 'Members club',
    memberPassTitle: 'Bazaarak — Bringing Home Closer',
    memberPassSubtitle: 'Your {{level}} tier unlocks festival perks & events',
    yourQrCode: 'Your QR code',
    scanToInvite: 'Friends can scan this code to join with your invite',
    festivalPerksTitle: 'Your festival benefits',
    festivalPerkAccess: 'Festival section access',
    festivalPerkDiscount: 'Festival-only discounts',
    festivalPerkGift: 'Special gifts & wrapping',
    festivalPerkPoints: 'Double points in festivals',
    festivalPerkVip: 'VIP event entry',
    festivalPerkEarly: 'Early access to sales',
  },
  gift: {
    title: 'Gift Card',
    balanceLabel: 'Gift card balance',
    useCta: 'Use gift card',
    sendTitle: 'Send gift card',
    sendHint: 'For friends and loved ones',
    buyTitle: 'Buy gift card',
    buyHint: 'A gift for every moment',
    buyForSelfOrOthers: 'For yourself or others',
    customAmount: 'Custom amount',
    enterCustomAmount: 'Enter amount',
    sendForLovedOnes: 'A gift for loved ones',
    recipientContact: 'Recipient mobile or email',
    congratsMessage: 'Congratulatory message (optional)',
    contactRequired: 'Enter recipient phone or email',
    selectAmountFirst: 'Select an amount first',
    amountInvalid: 'Enter a valid amount',
    historyTitle: 'Gift cards history',
    secureTitle: 'Safe and secure gift card',
    secureDesc: 'Gift cards are safe and reliable; contact support for help.',
    received: 'Received gift card',
    used: 'Used gift card',
    sent: 'Sent gift card',
    receivedFromBrand: 'Received gift card',
    fromPerson: 'From {{name}}',
    toPerson: 'To {{name}}',
    orderNo: 'Order #{{id}}',
    buyDesc: 'Choose an amount to add to your gift card balance.',
    selectedAmount: 'Selected',
    confirmBuy: 'Buy now',
    buySuccess: 'Gift card purchased',
    sendDesc: 'Send part of your gift balance to someone special.',
    available: 'Available',
    recipientName: 'Recipient name',
    recipientPhone: 'Phone (optional)',
    amount: 'Amount',
    message: 'Message (optional)',
    confirmSend: 'Send gift card',
    sendSuccess: 'Gift card sent',
    nameRequired: 'Enter recipient name',
    insufficient: 'Insufficient gift card balance',
    useTitle: 'Use gift card',
    redeemDesc: 'Enter your gift card code to add credit to your balance.',
    code: 'Gift card code',
    confirmRedeem: 'Redeem',
    redeemSuccess: 'Gift card redeemed',
    codeInvalid: 'Enter a valid gift card code',
    noHistory: 'No gift card activity yet',
    infoTitle: 'About gift cards',
    info1: 'Buy gift cards for yourself or send them to friends. Credits stay in your Bazaarak wallet.',
    info2: 'You can redeem codes, track history, and use your balance on eligible orders.',
    info3: 'Need help? Contact Support from your profile anytime.',
  },
  wishlist: {
    title: 'My Wishlist',
    saved: 'saved',
    totalValue: 'Total Value',
    potentialSavings: 'Potential Savings',
    inStock: 'In Stock',
    addToCart: 'Add to Cart',
    addAllToCart: 'Add All to Cart',
    shareWishlist: 'Share Wishlist',
    empty: 'Your Wishlist is Empty',
    emptyDesc: 'Start adding products you love to your wishlist',
    startShopping: 'Start Shopping',
    signIn: 'Please Sign In',
    signInDesc: 'Sign in to view your wishlist',
    removedFromWishlist: 'Removed from wishlist',
    backToProfile: 'Back to Profile',
    failedToLoad: 'Failed to load wishlist',
  },
  vendor: {
    dashboard: 'Vendor Dashboard',
    manageDashboard: 'Manage your store and track performance',
    editStore: 'Edit Store',
    addProduct: 'Add Product',
    createStory: 'Create Story',
    overview: 'overview',
    overviewTab: 'Overview',
    productsTab: 'products',
    storiesTab: 'stories',
    campaignsTab: 'Campaigns',
    joinCampaigns: 'Join Campaigns',
    myCampaigns: 'My Campaigns',
    activeCampaigns: 'Active Campaigns',
    howItWorks: 'How it works?',
    conditions: 'Conditions',
    eligibleProducts: 'Eligible Products',
    addProducts: 'Add Products',
    campaignCondDiscount: 'Min 10% discount',
    campaignCondStock: 'Sufficient stock',
    campaignCondShip: 'Ship from your warehouse',
    howCampaignsWork: 'How campaigns work?',
    howCampaignsWorkDesc:
      'Join platform campaigns, add eligible products with required discounts, and get more visibility in the app.',
    tipsForBetterResults: 'Tips for better results',
    tipPricing: 'Competitive Pricing',
    tipStock: 'Sufficient Stock',
    tipDelivery: 'Fast Delivery',
    payouts: 'Payouts',
    paymentsTab: 'Payments',
    deliveriesTab: 'Deliveries',
    analyticsTab: 'analytics',
    totalSales: 'Total Sales',
    orders: 'Orders',
    products: 'Products',
    customers: 'Customers',
    recentOrders: 'Recent Orders',
    viewAll: 'View All',
    inventoryAlerts: 'Inventory Alerts',
    manageInventory: 'Manage Inventory',
    myStories: 'My Stories',
    stories: 'stories',
    editStoreInfo: 'Edit Store Information',
    addNewProduct: 'Add New Product',
    editProduct: 'Edit Product',
    createNewStory: 'Create New Story',
    editStory: 'Edit Story',
    stripeAlertTitle: 'Stripe Account Not Connected',
    stripeAlertDesc: 'To earn revenue from product sales, connect your Stripe account first. Without it, adding products is not allowed.',
    stripeConnectBtn: 'Connect Stripe Account',
    stripeConnecting: 'Connecting...',
    stripeNoEmail: 'Store email is not set. Please enter an email in your store settings first.',
    stripeConnectFailed: 'Stripe connection failed. Please try again.',
    stripeStatusTitle: 'Stripe Status',
    stripeNotConnected: 'Stripe account not connected',
    stripeActive: 'Active',
    stripeInactive: 'Inactive',
    stripeCanSell: 'You can sell products',
    stripeCannotSell: 'Cannot sell products yet',
    stripeAccountId: 'Account ID',
    stripeContinueOnboarding: 'Continue Onboarding',
    stripeResetBtn: 'Reset Stripe',
    stripeResetTitle: 'Reset Stripe Account',
    stripeResetDesc: 'Are you sure? This will remove your Stripe account and you will need to connect again.',
    stripeResetConfirm: 'Yes, Reset',
    stripeResetting: 'Resetting...',
    stripeResetFailed: 'Failed to reset Stripe account',
    stripeProductsBlockTitle: 'Connect Stripe to Add Products',
    stripeProductsBlockDesc: 'Your store is not connected to Stripe yet. Complete the connection from the main dashboard first.',
    stripeBlockTitle: 'Stripe Connection Required',
    stripeBlockDesc: 'To add products and earn revenue, you must connect your Stripe account first.',
    dashboardWidgets: 'Dashboard widgets',
    dashboardWidgetsHint: 'Choose which cards appear on your overview dashboard.',
    widgetStoreHealth: 'Store health',
    widgetTotalSales: 'Total sales chart',
    widgetOrdersCustomers: 'Orders & customers',
    widgetProductsSummary: 'Products summary',
    widgetSalesPerformance: 'Sales performance',
    widgetOrderStatus: 'Order status',
    widgetTopProducts: 'Top selling products',
    widgetStoreInsights: 'Store insights',
    storeHealth: 'Store Health',
    storeActive: 'Store Active',
    storeSetup: 'Setup needed',
    sinceLabel: 'Since Jan 2024',
    profileComplete: 'Profile Complete',
    productsActive: 'Products Active',
    goodPerformance: 'Good Performance',
    setLocation: 'Set store location',
    vsLastMonth: 'vs last month',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    salesPerformance: 'Sales Performance',
    orderStatus: 'Order Status',
    topSellingProducts: 'Top Selling Products',
    storeInsights: 'Store Insights',
    activeProducts: 'Active',
    lowInStock: 'Low in stock',
    insightLowStock: '{{count}} products are running low on stock.',
    insightStockOk: 'Inventory levels look healthy.',
    insightSalesUp: 'Your sales increased by 24% this week.',
    insightOrdersAttention: '{{count}} orders require your attention.',
    fillRequired: 'Please fill in all required fields',
    saveFailed: 'Failed to save product',
    deleteFailed: 'Failed to delete product',
    storeNameLabel: 'Store Name',
    storeDescLabel: 'Store Description',
    ordersEmpty: 'No orders yet',
    salesLabel: 'sales',
    stockLeft: 'left',
    lowStock: 'Low Stock',
    revenueLabel: 'Revenue',
    categoryLabel: 'Category',
    orderLabel: 'Order',
    itemsLabel: 'items',
    guestCustomer: 'Guest Customer',
    noProductsYet: 'No products yet',
    addProductDesc: 'Add your first product to start selling',
    productNameLabel: 'Product Name',
    productNamePlaceholder: 'Enter product name',
    otherCategory: 'Other',
    productDescPlaceholder: 'Enter product description...',
    productImageLabel: 'Product Image',
    uploading: 'Uploading...',
    uploadImage: 'Upload Image',
    deleteProductTitle: 'Delete Product?',
    deleteProductDesc: 'Are you sure you want to delete',
    noProducts: 'No products yet',
    uploadNetworkError: 'Image upload via server is not available. Please enter an image URL instead.',
    useImageUrl: 'Image URL',
    hideUrl: 'Close URL',
    imageUrlHint: 'If image upload does not work, enter the direct image link:',
    imageUrlPlaceholder: '/uploads/example.jpg',
    applyUrl: 'Apply',
  },
  notifications: {
    title: 'Notifications',
    subtitle: 'Stay updated with your latest activity',
    unread: 'unread',
    markAllRead: 'Mark all read',
    allNotifications: 'All',
    unreadNotifications: 'Unread',
    noNotifications: 'No notifications',
    noNotificationsDesc: "You're all caught up! Check back later for updates.",
    markRead: 'Mark read',
    today: 'Today',
    yesterday: 'Yesterday',
    earlier: 'Earlier',
    settingsTitle: 'Notification Settings',
    settingsSubtitle: 'Manage what you want to see and how you get notified',
    pushTitle: 'Push Notifications',
    pushDesc: 'Receive notifications on your device',
    preferences: 'Notification Preferences',
    prefOrders: 'Orders & Deliveries',
    prefOrdersDesc: 'Updates about your orders and shipping',
    prefPromos: 'Promotions & Offers',
    prefPromosDesc: 'Deals, discounts and special offers',
    prefAlerts: 'Alerts & Reminders',
    prefAlertsDesc: 'Price drops and important reminders',
    prefMessages: 'Messages',
    prefMessagesDesc: 'Chat and support messages',
    prefWishlist: 'Wishlist Updates',
    prefWishlistDesc: 'When wishlist items change or drop in price',
    prefPayment: 'Payment & Billing',
    prefPaymentDesc: 'Payment confirmations and billing alerts',
    channels: 'Notification Channels',
    channelPush: 'Push Notifications',
    channelPushDesc: 'Instant notifications on your device',
    channelEmail: 'Email Notifications',
    channelEmailDesc: 'Receive updates via email',
    channelSms: 'SMS Notifications',
    channelSmsDesc: 'Important alerts via SMS',
    primary: 'Primary',
    dailyDigest: 'Daily Digest',
    instant: 'Instant',
    off: 'Off',
    important: 'Important',
    inControl: "You're in control",
    inControlDesc: 'You can change your preferences anytime.',
  },
  addresses: {
    title: 'My Addresses',
    yourAddresses: 'Your Addresses',
    yourSavedAddresses: 'Your Saved Addresses',
    savedCount: 'You have {{count}} saved addresses',
    manageHint: 'Manage your delivery addresses.',
    secureTitle: 'Secure & Private',
    secureDesc: 'Your addresses are safe with us and will only be used for deliveries.',
    saved: 'saved',
    location: 'location',
    locations: 'locations',
    addNew: 'Add New',
    noAddresses: 'No Addresses Yet',
    noAddressesDesc: 'Add your first delivery address to get started',
    addAddress: 'Add Address',
    signIn: 'Please Sign In',
    signInDesc: 'Sign in to manage your addresses',
    addNewAddress: 'Add New Address',
    editAddress: 'Edit Address',
    deleteAddress: 'Delete Address?',
    deleteAddressDesc: 'Are you sure you want to delete',
    cannotBeUndone: 'This action cannot be undone.',
    setDefault: 'Set as default',
    backToProfile: 'Back to Profile',
    default: 'Default',
    label: 'Address Label',
    street: 'Street Address',
    city: 'City',
    state: 'State / Region',
    zip: 'Postal Code',
    country: 'Country',
    mapPreview: 'Map Preview',
    saveAddress: 'Save Address',
    searchPlaceholder: 'Search for your address...',
    labelPlaceholder: 'Home, Work...',
    typeHome: 'Home',
    typeWork: 'Work',
    typeOther: 'Other',
    tapMapHint: 'Tap map to adjust exact location',
    tapMapAdjust: 'Tap on the map to move the pin',
    switchToSearch: 'Switch to Search tab to add one',
    searchFailed: 'Search failed. Please try again.',
    addressFallback: 'Address',
    searchTab: 'Search',
    savedTab: 'Saved',
    resultsFound: 'results',
    startTypingHint: 'Start typing your address...',
    namePlaceholder: 'Enter your full name',
    phonePlaceholder: '+1 234 567 8900',
    autoFilledHint: 'Address fields auto-filled. You can edit them.',
    editPin: 'Edit Pin',
    locationType: 'Location Type',
    selectLocationType: 'Select location type',
    apartment: 'Apartment',
    house: 'House',
    office: 'Office',
    outdoor: 'Outdoor / Meet-up',
    doorbellName: 'Name on doorbell',
    doorbellNamePlaceholder: 'e.g. "John Doe"',
    entrance: 'Entrance',
    entrancePlaceholder: 'e.g. "Entrance B"',
    additionalInfo: 'Additional info for the rider',
    additionalInfoPlaceholder: 'Directions for the courier...',
    addressRequired: 'Please select an address',
    phoneRequired: 'Phone number is required',
  },
  payment: {
    title: 'Payment Methods',
    manageSubtitle: 'Add or manage your payment methods',
    secureEncrypted: 'Your payment information is secure and encrypted',
    orderSummary: 'Order Summary',
    paymentMethod: 'Payment Method',
    payNow: 'Pay Now',
    processing: 'Connecting to gateway...',
    loading: 'Loading order...',
    orderNotFound: 'Order Not Found',
    invalidOrder: 'Invalid Order ID',
    invalidOrderDesc: 'The order was not found. Please return to your orders.',
    loadError: 'Failed to load payment information',
    payError: 'Failed to create payment session',
    noCheckoutUrl: 'Payment gateway unavailable',
    noItems: 'This order has no items',
    noSavedMethods: 'No payment methods saved yet',
    addMethod: 'Add Payment Method',
    savePaymentMethod: 'Save Payment Method',
    addPaymentMethod: 'Add Payment Method',
    addPaymentMethodTitle: 'Add Payment Method',
    card: 'Card',
    bankTransfer: 'Bank Transfer',
    default: 'Default',
    unknownMethod: 'Unknown Method',
    secureDesc: 'Secure payment with SSL encryption',
    saved: 'saved',
    method: 'method',
    methods: 'methods',
    addNew: 'Add New',
    noPaymentMethods: 'No Payment Methods Yet',
    noPaymentMethodsDesc: 'Add your first payment method to get started',
    setDefault: 'Set Default',
    deletePaymentMethod: 'Delete Payment Method?',
    deleteDesc: 'Are you sure you want to delete this payment method? This action cannot be undone.',
    backToProfile: 'Back to Profile',
    paypal: 'PayPal',
    bank: 'Bank',
    cardNumber: 'Card Number',
    cardHolder: 'Card Holder Name',
    expiryDate: 'Expiry Date',
    cvv: 'CVV',
    cardType: 'Card Type',
    paypalEmail: 'PayPal Email',
    bankName: 'Bank Name',
    accountNumber: 'Account Number',
    setAsDefault: 'Set as default payment method',
    cardHolder_placeholder: 'Full name on card',
    editPaymentMethod: 'Edit Payment Method',
    saveChanges: 'Save Changes',
    expires: 'Expires',
    cardHolderLabel: 'Card Holder',
  },
  security: {
    title: 'Security Settings',
    manageDesc: 'Manage your account security',
    changePassword: 'Change Password',
    changePasswordDesc: 'Update your account password',
    twoFA: 'Two-Factor Authentication',
    twoFADesc: 'Add an extra layer of security',
    biometric: 'Biometric Login',
    biometricDesc: 'Use fingerprint or face to login',
    activeSessions: 'Active Sessions',
    activeDevices: '{{count}} active devices',
    loginHistory: 'Login History',
    viewRecentActivity: 'View recent account activity',
    deleteAccount: 'Delete Account',
    deleteDesc: 'Permanently remove account',
    permanentlyDelete: 'Permanently delete your account',
    accountProtected: 'Your account is protected',
    dataSafe: 'We keep your data safe and secure.',
    on: 'On',
    off: 'Off',
    recentLoginActivity: 'Recent Login Activity',
    enable2FA: 'Enable 2FA',
    disable2FA: 'Disable 2FA',
    sessions: 'active devices',
    enable2FATitle: 'Enable Two-Factor Authentication',
    disable2FATitle: 'Disable Two-Factor Authentication',
    enable2FADesc: 'Add an extra layer of security to your account with 2FA.',
    disable2FADesc: 'Your account will be less secure without 2FA protection.',
    activeSessionsTitle: 'Active Sessions',
    updatePassword: 'Update Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    enterCurrentPassword: 'Enter current password',
    enterNewPassword: 'Enter new password',
    confirmNewPassword: 'Confirm new password',
    passwordsDoNotMatch: 'Passwords do not match!',
    passwordMinLength: 'Password must be at least 8 characters!',
    scanQRCode: 'Scan QR Code',
    useAuthenticator: 'Use Google Authenticator or similar app',
    success: 'Success',
    failed: 'Failed',
    backToProfile: 'Back to Profile',
    current: 'Current',
    logout: 'Logout',
    deleteAccountTitle: 'Delete Account',
    deleteAccountDesc: 'This action cannot be undone. All your data will be permanently deleted.',
    deleteWarning: '• All orders and purchase history will be deleted\n• Saved addresses and payment methods will be removed\n• Wishlist items will be lost\n• This action is irreversible',
  },
  help: {
    title: 'Help & Support',
    subtitle: "We're here to help you 24/7",
    chooseOption: 'Choose a support option',
    quickHelp: 'Quick Help',
    faqsShort: 'FAQs',
    accountOrders: 'Account & Orders',
    paymentsRefunds: 'Payments & Refunds',
    hereForYou: "We're here for you",
    hereForYouDesc: 'Our support team is always ready to help and solve your issues.',
    liveChat: 'Live Chat',
    liveChatDesc: 'Chat with our support team',
    available247: 'Available 24/7',
    emailSupport: 'Email Support',
    emailSupportDesc: 'support@bazarak.com',
    responseTime: 'Response within 24 hours',
    phoneSupport: 'Phone Support',
    phoneSupportDesc: '+49 30 1234 5678',
    monFri: 'Mon-Fri, 9AM-6PM CET',
    whatsapp: 'WhatsApp',
    whatsappDesc: 'Message us on WhatsApp',
    faq: 'Frequently Asked Questions',
    allTopics: 'All Topics',
    orders: 'Orders',
    payments: 'Payments',
    shipping: 'Shipping',
    returns: 'Returns',
    account: 'Account',
    quickLinks: 'Quick Links',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    refund: 'Refund Policy',
    shippingPolicy: 'Shipping Policy',
    stillNeedHelp: 'Still need help?',
    stillNeedHelpDesc: "Can't find what you're looking for? Our support team is ready to assist you.",
    contactSupport: 'Contact Support',
    contactSupportTitle: 'Contact Support',
    yourName: 'Your Name',
    emailAddress: 'Email Address',
    subject: 'Subject',
    message: 'Message',
    sendMessage: 'Send Message',
    noFaqFound: 'No FAQs found in this category',
    startChat: 'Start Chat',
    sendEmail: 'Send Email',
    callNow: 'Call Now',
    openWhatsApp: 'Open WhatsApp',
    backToProfile: 'Back to Profile',
    subjectPlaceholder: 'What can we help you with?',
    messagePlaceholder: 'Please describe your issue in detail...',
    namePlaceholder: 'Enter your name',
  },
  footer: {
    quickLinks: 'Quick Links',
    support: 'Support',
    downloadApp: 'Download App',
    description: 'Bazaarak, online store for fresh and quality products. Guaranteed best prices and fastest delivery.',
    rights: '© 2026 Bazaarak. All rights reserved.',
    contactUs: 'Contact Us',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    helpCenter: 'Help Center',
    appStore: 'App Store',
    googlePlay: 'Google Play',
  },
  language: {
    title: 'Language',
    persian: 'Persian',
    english: 'English',
    german: 'German',
    turkish: 'Turkish',
    arabic: 'Arabic',
    selectLanguage: 'Select Language',
    currentLanguage: 'Current Language',
    availableLanguages: 'Available Languages',
    changeInfo: 'Changing the language will update the entire app interface immediately.',
    switchConfirm: 'Switch to {{name}} ({{native}})?',
  },
  datetime: {
    title: 'Schedule Delivery',
    quickSelect: 'Quick Select',
    selectDate: 'Select Date',
    selectTime: 'Select Time',
    today: 'Today',
    tomorrow: 'Tomorrow',
    dayAfter: 'Day After',
    nextWeek: 'Next Week',
    su: 'Su',
    mo: 'Mo',
    tu: 'Tu',
    we: 'We',
    th: 'Th',
    fr: 'Fr',
    sa: 'Sa',
    deliveryTo: 'Deliver to',
    pickupFrom: 'Pickup from',
    courierArrives: 'Courier will arrive during this window',
    readyForPickup: 'Your order will be ready for pickup',
    confirmSchedule: 'Confirm Schedule',
    selectDateTime: 'Select date & time',
    selectAndConfirm: 'Select and confirm',
    morning: 'Morning',
    noon: 'Noon',
    afternoon: 'Afternoon',
    evening: 'Evening',
  },
  bazaarHub: {
    title: 'Bazaarak',
    subtitle: 'Everything in one place',
    categories: 'Categories',
    search: 'Search',
    cart: 'Cart',
    orders: 'Orders',
    profile: 'Profile',
    wishlist: 'Wishlist',
    offers: 'Offers',
    vendors: 'Vendors',
    addresses: 'Addresses',
    notifications: 'Notifications',
    settings: 'Settings',
    help: 'Help',
  },
  theme: {
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
  },
  search: {
    productLabel: 'Products',
    categoryLabel: 'Categories',
    wishlistLabel: 'Wishlist',
    offerLabel: 'Offers',
    addressLabel: 'Addresses',
    vendorLabel: 'Vendors',
    for: 'for',
    filteringBy: 'Filtering by',
    clearCategoryFilter: 'Clear category filter',
    relevance: 'Relevance',
    priceLowToHigh: 'Price: Low to High',
    priceHighToLow: 'Price: High to Low',
    newest: 'Newest',
    topRated: 'Top Rated',
    allPrices: 'All Prices',
    allRatings: 'All Ratings',
    sortBy: 'Sort By',
    priceRange: 'Price Range',
    rating: 'Rating',
    filters: 'Filters',
    applyFilters: 'Apply Filters',
    clearAllFilters: 'Clear all filters',
    brand: 'Brand',
    color: 'Color',
    size: 'Size',
    allBrands: 'All Brands',
    allColors: 'All Colors',
    allSizes: 'All Sizes',
    noBrands: 'No brands available',
    noColors: 'No colors available',
    noSizes: 'No sizes available',
    typeToFind: 'Type to find products, categories, and more',
    resultsFor: 'Search results for',
    resultsFound: 'results found',
    items: 'Items',
    stores: 'Stores',
    categories: 'Categories',
    itemFound: 'item',
    storeFound: 'store',
    categoryFound: 'category',
    tryDifferentKeywords: 'Try different keywords',
    noProductsFound: 'No products found',
    noStoresFound: 'No stores found',
    noCategoriesFound: 'No categories found',
  },
  aiAssistant: {
    title: 'AI Assistant',
    subtitle: 'How can I help you?',
    hotDeals: 'Hot Deals',
    trackOrder: 'Track Order',
    popular: 'Popular',
    findStores: 'Find Stores',
    comingSoon: 'Smart AI features coming soon!',
    askAnything: 'Ask anything...',
    errorReply: 'Sorry, something went wrong. Please try again.',
  },
  stores: {
    title: 'All Stores',
    stores: 'stores',
    searchPlaceholder: 'Search stores by name, city, or tag...',
    sortPopular: 'Popular',
    sortRating: 'Top Rated',
    sortNewest: 'Newest',
    sortProducts: 'Most Products',
    endOfList: 'End of list',
    products: 'products',
    reviews: 'reviews',
  },
  errors: {
    loadFailed: 'Failed to load data. Please try again.',
    noResults: 'No results found',
    uploadFailed: 'Image upload failed. Please try again.',
  },
  admin: {
    title: 'Admin Panel',
    menu: 'Menu',
    backToSite: 'Back to Site',
    dashboard: 'Dashboard',
    users: 'Users',
    stores: 'Stores',
    products: 'Products',
    orders: 'Orders',
    categories: 'Categories',
    search: 'Search in this section...',
    totalUsers: 'Total Users',
    totalStores: 'Total Stores',
    totalProducts: 'Total Products',
    totalOrders: 'Total Orders',
    totalRevenue: 'Total Revenue',
    pendingOrders: 'Pending Orders',
    quickActions: 'Quick Actions',
    addCategory: 'Add Category',
    addProduct: 'Add Product',
    viewOrders: 'View Orders',
    manageUsers: 'Manage Users',
    name: 'Name',
    email: 'Email',
    role: 'Role',
    joined: 'Joined',
    storeName: 'Store Name',
    address: 'Address',
    rating: 'Rating',
    products: 'Products',
    productName: 'Product Name',
    price: 'Price',
    stock: 'Stock',
    status: 'Status',
    orderId: 'Order ID',
    customer: 'Customer',
    total: 'Total',
    date: 'Date',
    categoryName: 'Category Name',
    parentCategory: 'Parent Category',
    mainCategory: 'Main Category',
    noneTopLevel: 'None (Top Level)',
    sortOrder: 'Sort Order',
    confirmDelete: 'Confirm Delete',
    confirmDeleteDesc: 'Are you sure you want to delete this item? This action cannot be undone.',
    edit: 'Edit',
    banners: 'Banners',
    campaigns: 'Campaigns',
    campaignFlash: 'Flash sale (orange)',
    campaignSeasonal: 'Seasonal / pack (blue)',
    campaignCoverUrl: 'Cover / icon image URL',
    createCampaign: 'Create campaign',
    campaignProducts: 'Campaign products',
    campaignTitleRequired: 'Title is required',
    noCampaigns: 'No campaigns yet',
    reviews: 'Reviews',
    addBanner: 'Add Banner',
    editBanner: 'Edit Banner',
    bannerTitle: 'Banner Title',
    bannerSubtitle: 'Subtitle',
    bannerImageUrl: 'Image URL',
    bannerLinkUrl: 'Link URL',
    bannerPosition: 'Position',
    bannerActive: 'Active',
    bannerInactive: 'Inactive',
    homeTop: 'Home Top',
    homeMiddle: 'Home Middle',
    storePage: 'Store Page',
    reviewUser: 'User',
    reviewTarget: 'Target',
    reviewRating: 'Rating',
    reviewComment: 'Comment',
    reviewApproved: 'Approved',
    reviewPending: 'Pending',
    approve: 'Approve',
    reject: 'Reject',
    product: 'Product',
    store: 'Store',
    noBanners: 'No banners found',
    noReviews: 'No reviews found',
    canAddProducts: 'Allow Adding Products',
  },
  reviews: {
    title: 'Reviews & Ratings',
    customerReviews: 'Customer Reviews',
    averageRating: 'Average Rating',
    outOf5: 'out of 5',
    basedOn: 'Based on',
    review: 'review',
    writeReview: 'Write a Review',
    yourRating: 'Your Rating',
    yourReview: 'Your Review',
    reviewTitle: 'Review Title',
    reviewPlaceholder: 'Share your experience with this product...',
    titlePlaceholder: 'Write a summary of your review',
    submitReview: 'Submit Review',
    submitting: 'Submitting...',
    loadMore: 'Load More',
    noReviews: 'No reviews yet',
    noReviewsDesc: 'Be the first to leave a review!',
    signInToReview: 'Sign in to write a review',
    reviewSubmitted: 'Your review has been submitted!',
    reviewFailed: 'Failed to submit review',
    helpful: 'Helpful',
    report: 'Report',
    verified: 'Verified Buyer',
    sortNewest: 'Newest',
    sortHighest: 'Highest Rated',
    sortLowest: 'Lowest Rated',
  },
};